import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setPrevPage, setNextPage } from '../../../redux/slices/appStateSlice';

const ConfirmChildDetailsLogic = ({ fields, dependents }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (dependents?.spouse) {
      dispatch(setPrevPage(fields.confirmPartnerDetailsPage?.value?.href));
    } else {
      dispatch(setPrevPage(fields.confirmDetailsPage?.value?.href));
    }
  }, [dependents]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    dependents: state.quoteData?.prospectDetails?.dependents,
  };
};
export default connect(mapStateToProps)(ConfirmChildDetailsLogic);
